<template>
  <div class="service_pop_warp">
    <el-popover placement="right" width="624" trigger="click" @hide="handleHidePop">
      <div class="service_pop_one_box" v-show="(step === 1)">
        <div class="service_pop_one_top">
          <div class="service_pop_one_title">反馈建议记录</div>
          <div class="service_pop_one_next" @click="(step = 2)">去提交反馈</div>
        </div>
        <el-table :cell-style="getRowClass" :data="tableData" max-height="300" :expand-row-keys="expands" @row-click="clickRowHandle"
          row-key="id">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <pre v-html="scope.row.describe" style="word-break: break-all;white-space: pre-wrap;margin: 0;"></pre>
            </template>
          </el-table-column>
          <el-table-column width="40" property="id" label="ID"></el-table-column>
          <el-table-column width="70" property="user" label="人员">
            <template slot-scope="scope">
              {{ users[scope.row.user] || '...' }}
            </template>
          </el-table-column>
          <el-table-column width="120" property="describe" label="内容">
            <template slot-scope="scope">
              <pre v-html="scope.row.describe" class="describe"></pre>
            </template>
          </el-table-column>
          <el-table-column width="130" property="attachment" label="附件">
            <template slot-scope="scope">
              <a @click.stop="handleClickLink(item)" class="attachmentStyle"
                v-for="(item, index) in scope.row.attachment" :key="index">附件{{ (index + 1) }}</a>
            </template>
          </el-table-column>
          <el-table-column width="100" property="create_time" align="center" label="提交时间"></el-table-column>
          <el-table-column width="104" property="status" align="center" label="状态">
            <template slot-scope="scope">
              <el-popover :disabled="scope.row.dcm === 0" trigger="hover" placement="top">
                <div class="status_tabs">
                  <el-tag class="status_tab" disable-transitions size="mini" v-show="key !== scope.row.status"
                    v-for="(value, key) in statusOptions" :key="key" :type="value"
                    @click="handleChangeStatus(scope.row.id, key)">{{ key
}}</el-tag>
                </div>
                <div slot="reference" class="status_tab">
                  <el-tag size="mini" disable-transitions :type="statusOptions[scope.row.status]">{{ scope.row.status }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <template #empty>
            <el-empty v-loading="tableLoading" :image-size="200"></el-empty>
            <div v-if="!tableLoading">暂无数据</div>
          </template>
        </el-table>
      </div>
      <div class="service_pop_two_box" v-show="(step === 2)">
        <div class="service_pop_two_top">
          <div class="service_pop_two_title">提交反馈</div>
          <div class="service_pop_two_pre" @click="handleLinkToStep(1)">反馈建议记录</div>
        </div>
        <div class="suggest_label">*<span>关于DevOps的使用您是否满意？</span></div>
        <div class="suggest_star_list">
          <el-tooltip class="item" :content="item.hoverText" placement="bottom" v-for="(item, index) in starList"
            :key="index">
            <svg class="star_icon" aria-hidden="true" :style="currentStarHoverIndex >= index && 'fill:#E6A23C;'"
              @mouseenter="mouseenter(index)" @mouseleave="mouseleave()" @click="handleStar(index)">
              <use xlink:href="#icon-shoucang" />
            </svg>
          </el-tooltip>
        </div>
        <div class="suggest_label">*<span>关于DevOps您还有那些建议？</span></div>
        <textarea name="" id="" class="suggest_descrip" cols="80" rows="5" v-model="describe">
          {{ describe }}
        </textarea>
        <el-upload class="upload-demo" action="https://devops-test.ehsy.com/devops/common/upload"
          :on-preview="handlePreview" :limit="3" multiple :on-success="handleSuccess" :on-remove="handleRemove"
          :file-list="fileList" :on-exceed="handleExceed">
          <div style="display: flex;align-items: center;">
            <div class="self_btn"><i class="el-icon-plus"></i>上传附件</div>
            <span slot="tip" style="color: red;margin-left: 10px;font-size: 12px;">最多可上传3个附件</span>
          </div>
        </el-upload>
        <div class="suggest_btn">
          <el-button style="margin-left:5px;" size="mini" @click="onReset()">重置</el-button>
          <el-button size="mini" @click="onSubmitSuggest()" type="primary" :loading="loading">提交</el-button>
        </div>
      </div>
      <svg slot="reference" class="self_menu_icon" aria-hidden="true">
        <use xlink:href="#icon-xiepinglun"></use>
      </svg>
    </el-popover>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { getSuggestListApi, postSuggestCreateApi, postSuggestUpdateApi } from "@/server/tops/devOps.js"
export default {
  props: {

  },
  data() {
    return {
      tableData: [],
      step: 2,
      currentStarHoverIndex: 4, // 划过的星星下标
      currentStarIndex: 4, // 选中的星星下标
      starList: [ // 星星配置
        {
          hoverText: '非常不满意',
        },
        {
          hoverText: '不满意',
        },
        {
          hoverText: '一般',
        },
        {
          hoverText: '满意',
        },
        {
          hoverText: '非常满意',
        }
      ],
      describe: '', // 默认描述格式
      fileList: [], // 附件上传
      loading: false, // 提交loading
      statusOptions: {
        '待解决': 'info',
        '未采纳': 'danger',
        '已解决': 'success',
        '解决中': ''
      }, // 建议状态
      expands: [], // 展开行
      tableLoading: false, // 表格loading
    }
  },
  computed: {
    ...mapState(
      {
        users: (state) => state.devOps.ALLSELECT.TEXTUSERS,
      }
    ),
  },
  created() {
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  methods: {
    // 行样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "padding:0;";
    },
    async getList() {
      try {
        this.tableLoading = true;
        const ret = await getSuggestListApi()
        if (ret.status === 'success') {
          this.tableData = ret.data.map(item => {
            item.attachment = item.attachment ? item.attachment.split(',') : [];
            return item
          });
        }
      } catch (error) {
      } finally {
        this.tableLoading = false;
      }
    },
    async handleChangeStatus(id, status) {
      try {
        const param = {
          id, status
        }
        const ret = await postSuggestUpdateApi(param)
        if (ret.status === 'success') {
          this.getList()
        }
      } catch (error) { }
    },
    // 提交
    async onSubmitSuggest() {
      try {
        if (!this.describe) {
          this.$notify({
            message: "请输入您的建议",
            type: "warning",
          })
          return;
        }
        this.loading = true;
        const attachment = this.fileList.map(item => {
          return item.response.url
        }).toString()
        const param = {
          describe: this.describe,
          star: this.currentStarIndex + 1,
          attachment
        }
        const ret = await postSuggestCreateApi(param)
        this.$notify({
          message: ret.status === 'success' ? '提交成功' : "提交失败",
          type: ret.status === 'success' ? "success" : "error"
        })
        if (ret.status === 'success') {
          this.onReset()
        }
      } catch (error) { } finally {
        this.loading = false;
      }
    },
    // 重置
    async onReset() {
      this.describe = '';
      this.currentStarIndex = 4;
      this.currentStarHoverIndex = 4;
      this.fileList = []
      this.expands = []
    },
    // 表格行点击
    clickRowHandle(row, column, event) {
      if (this.expands.includes(row.id)) {
        this.expands = this.expands.filter(val => val !== row.id);
      } else {
        this.expands.push(row.id);
      }
    },
    // 跳转外部链接
    handleClickLink(item) {
      window.open(item)
    },
    // 文件超过最大数量
    handleExceed(files, fileList) {
      this.$notify({
        message: `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
        type: "warning",
      })
    },
    // pop隐藏时触发
    handleHidePop() {
      this.step = 2;
    },
    // 跳转列表
    handleLinkToStep(step) {
      this.getList()
      this.step = step;
      this.onReset()
    },
    // 鼠标滑入效果
    mouseenter(index) {
      this.currentStarHoverIndex = index;
    },
    // 鼠标滑出效果
    mouseleave() {
      this.currentStarHoverIndex = this.currentStarIndex;
    },
    // 选中星星
    handleStar(index) {
      this.currentStarIndex = index;
    },
    handlePreview(file) {
      window.open(file?.response?.url || '')
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    }
  }
};
</script>
<style lang="scss" scoped>
.self_menu_icon {
  width: 20px;
  height: 20px;
  fill: #707070;
  overflow: hidden;
  background-color: #fff;
  padding: 8px;
  border-radius: 50%;
  box-shadow: 0 0 7px -3px #707070;
  margin-top: 5px;
}

.el-table--scrollable-y .el-table__body-wrapper {
  overflow: hidden !important;
}

.upload-demo {
  margin-left: 5px;
  margin-bottom: 10px;

  .self_btn {
    border: 1px solid #ccc;
    padding: 2px 3px;
  }
}

.status_tabs {
  display: flex;
  justify-content: space-around;
  min-width: 170px;
}

.status_tab {
  cursor: pointer;
}

.attachmentStyle {
  text-decoration: none;
  white-space: nowrap;
  margin-right: 5px;
  display: inline-block;
  cursor: pointer;
  color: #409EFF;
}

.describe {
  // overflow: hidden;
  // text-overflow: ellipsis;
  // display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
  // -webkit-box-orient: vertical; // 从上到下垂直排列子元素
  // -webkit-line-clamp: 2; //显示的行数

  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //用省略号显示
  white-space: nowrap; //不换行
}

/* #region 滚动条部分 */
.suggest_descrip {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
  outline: none;
  border: 1px solid #ccc;
  font-size: 14px;
  margin-left: 5px;
  resize: none;
  width: 98%;
}

.suggest_descrip:focus {
  outline: none;
  border: 1px solid #ccc;
}

.suggest_descrip::-webkit-scrollbar,
.service_pop_two_box::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.suggest_descrip::-webkit-scrollbar-thumb,
.service_pop_two_box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.suggest_descrip::-webkit-scrollbar-track,
.service_pop_two_box::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.star_icon {
  width: 30px;
  height: 30px;
  fill: #cdcdcd;
  overflow: hidden;
  background-color: #fff;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
}

.current_active {
  color: rgb(64, 158, 255);
  cursor: pointer;
}



.service_pop_one_box {
  .service_pop_one_top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .service_pop_one_title {
      font-weight: bold;
      color: #666;
      font-size: 17px;
      margin-left: 10px;
      transform: translateY(10px);
    }

    .service_pop_one_next {
      color: #409EFF;
      cursor: pointer;
      text-decoration: underline;
      transform: translateY(10px);
    }
  }
}

.service_pop_two_box {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;

  .service_pop_two_top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 10px;

    .service_pop_two_title {
      font-weight: bold;
      color: #666;
      font-size: 17px;
      margin-left: 10px;
      transform: translateY(10px);
    }

    .service_pop_two_pre {
      color: #409EFF;
      cursor: pointer;
      text-decoration: underline;
      transform: translateY(10px);

    }


  }

  .suggest_btn {
    display: flex;
    justify-content: flex-end;
  }

  .suggest_label {
    color: red;

    span {
      color: #666;
      font-weight: bold;
      margin: 5px;
      display: inline-block;
    }

  }

}
</style>
